import styled from 'styled-components';

export const DigitalExpertWrapper = styled.div`
  max-width: 303px;
  margin: 0 40px 32px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AvatarImageWrapper = styled.div`
  margin-bottom: 20px;

  @media (min-width: 768px) {
    margin-bottom: 26px;
  }

  [class^='Interactionstyle__BlankInteraction-sc'] {
    width: 124px;
    height: 124px;
  }
`;

export const ExpertNameWrapper = styled.div`
  text-align: center;
  margin-bottom: 12px;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
`;

export const ExpertSummaryWrapper = styled.div`
  div {
    margin-bottom: 0;

    p {
      margin: 0;

      @media (min-width: 768px) {
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
`;
